// cspell:ignore UNNORMALIZED

import { MAX_YEAR, MIN_YEAR } from 'components/YearPicker'
import { EMPTY_FORM_VALUE } from 'utils-next/forms'
import * as Yup from 'yup'

import { SearchEngineQueryData } from '../../SearchEngine.types'
import { SEVersionOptions, SourceOptions } from './SearchEngineBar.component'

export function getSearchEngineQueryDataValidation() {
  return Yup.object().shape({
    keywords: Yup.string().required(),
    negativeKeywords: Yup.string(),
    secondaryKeywords: Yup.string(),
    secondaryNegativeKeywords: Yup.string(),
    locations: Yup.string().matches(/(.+?)(?:,|$)/g, 'Values must be comma separated'),
    negativeLocations: Yup.string().matches(/(.+?)(?:,|$)/g, 'Values must be comma separated'),
    stages: Yup.string().matches(/(.+?)(?:,|$)/g, 'Values must be comma separated'),
    includeCompaniesWithoutMaturityInformation: Yup.bool(),
    minimumYear: Yup.number()
      .min(MIN_YEAR, `Value cannot be under ${MIN_YEAR}`)
      .max(MAX_YEAR, `Value cannot be over ${MAX_YEAR}`)
      .nullable(),
    maximumYear: Yup.number()
      .min(MIN_YEAR, `Value cannot be under ${MIN_YEAR}`)
      .max(MAX_YEAR, `Value cannot be over ${MAX_YEAR}`)
      .nullable(),
    seVersion: Yup.string(),
    sourceFilter: Yup.string(),
  })
}

export function getEmptySearchQueryData(): SearchEngineQueryData {
  return {
    keywords: EMPTY_FORM_VALUE,
    negativeKeywords: EMPTY_FORM_VALUE,
    secondaryKeywords: EMPTY_FORM_VALUE,
    secondaryNegativeKeywords: EMPTY_FORM_VALUE,
    locations: EMPTY_FORM_VALUE,
    negativeLocations: EMPTY_FORM_VALUE,
    stages: EMPTY_FORM_VALUE,
    includeCompaniesWithoutMaturityInformation: true,
    seVersion: SEVersionOptions.POOL_ATLAS,
    sourceFilter: SourceOptions.ALL,
  }
}
